import { render, staticRenderFns } from "./UnassignedWatermetersButton.vue?vue&type=template&id=513e9415&"
import script from "./UnassignedWatermetersButton.vue?vue&type=script&lang=js&"
export * from "./UnassignedWatermetersButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports